import { forwardRef, type Ref, type SVGProps } from "react";
const IconRateVeryHappyOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 2A14 14 0 1 1 2 16 14 14 0 0 1 16 2m0 2a12 12 0 1 0 12 12A12 12 0 0 0 16 4m6.08 13.43a1 1 0 0 1 1 1c0 3.07-3.39 6.13-7.08 6.13s-7.08-3.06-7.08-6.13a1 1 0 0 1 1-1zm-1.21 2h-9.74v.14a5.57 5.57 0 0 0 4.6 3H16a5.55 5.55 0 0 0 4.82-3ZM12 11a2 2 0 1 1-2 2 2 2 0 0 1 2-2m8 0a2 2 0 1 1-2 2 2 2 0 0 1 2-2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRateVeryHappyOutlineSVG);
ForwardRef.displayName = "IconRateVeryHappyOutline";
export { ForwardRef as IconRateVeryHappyOutline };
